<div class="font-semibold pl-1 text-red-600 text-left">
  <ng-content></ng-content>
</div>
